/**
 * es-AR number formatting — the single shared helper the merchant handoff
 * mandates (docs/design/design_handoff_merchant/README.md → "Formato de números"):
 *   $ 23.990.362   currency: "$" + space, dot thousands, no decimals
 *   17.492         integers with dot thousands
 *   1.1%           percentages with DOT decimal, one decimal place
 */

const intFmt = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 })

export function fmtInt(n: number): string {
  return intFmt.format(Math.round(n))
}

export function fmtMoney(n: number): string {
  return `$ ${intFmt.format(Math.round(n))}`
}

/** Fraction (0–1) → "1.1%". Dot decimal by explicit design rule, not locale. */
export function fmtPct(fraction: number): string {
  return `${(fraction * 100).toFixed(1)}%`
}
